import { render, staticRenderFns } from "./ButtonComponent.vue?vue&type=template&id=51771615&scoped=true"
import script from "./ButtonComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonComponent.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ButtonComponent.vue?vue&type=style&index=0&id=51771615&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51771615",
  null
  
)

export default component.exports